module.exports = __webpack_public_path__ + "static/media/profile-pic.f671ab3b.png";